module.exports = __webpack_public_path__ + "static/media/p_16_4.37f71d47.png";